import React from 'react';
import { Search, Bell, Plane } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import { Button } from './ui/button';

const HowItWorksSection = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const steps = [
    {
      icon: Search,
      number: "1",
      title: t.findDeals,
      description: t.findDealsDesc,
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-500'
    },
    {
      icon: Bell,
      number: "2",
      title: t.getNotified,
      description: t.getNotifiedDesc,
      bgColor: 'bg-purple-100',
      iconColor: 'text-purple-500'
    },
    {
      icon: Plane,
      number: "3",
      title: t.bookSave,
      description: t.bookSaveDesc,
      bgColor: 'bg-orange-100',
      iconColor: 'text-orange-500'
    }
  ];

  return (
    <section id="how" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16">{t.howItWorks}</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div 
                key={index} 
                className="bg-white p-8 rounded-xl shadow-md text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-2"
              >
                <div className={`${step.bgColor} w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6`}>
                  <Icon className={`${step.iconColor} w-10 h-10`} />
                </div>
                <h3 className="text-xl font-bold mb-3">{step.number}. {step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
            );
          })}
        </div>
        
        <div className="text-center">
          <h3 className="text-2xl font-bold mb-6">{t.readyToStart}</h3>
          <Button
            onClick={() => scrollToSection('pricing')}
            className="bg-gradient-to-r from-orange-500 to-purple-500 hover:from-orange-600 hover:to-purple-600 text-white font-bold py-6 px-8 rounded-full text-lg transition-all duration-300 transform hover:scale-105"
          >
            {t.viewPricing}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
